import { useState } from "react";
import { Link } from "react-router-dom";
import {
  ArrowUpRightIcon,
  PlusIcon,
  PlayIcon,
  CodeBracketIcon,
} from "@heroicons/react/24/outline";
import handleAddCourse from "../../apis/addCourse";
import { getUser } from "../../services/Authservice";
import { signInWithGoogle } from "../../apis/Signin";

export default function CourseCard({ course }) {
  const [saving, setSaving] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);
  const enroll = async () => {
    const uid = getUser()?.emails[0].value;
    if (!uid) return signInWithGoogle();
    setSaving(true);
    try {
      await handleAddCourse(course, uid);
    } finally {
      setSaving(false);
    }
  };
  return (
    <article className="course-card">
      <Link
        className="course-cover"
        to="/video-player"
        state={{ playlistID: course.playlistID, tracking: false }}
        aria-label={`Preview ${course.title}`}
      >
        {course.avatar && !imageFailed ? (
          <img
            src={course.avatar}
            alt=""
            loading="lazy"
            onError={() => setImageFailed(true)}
          />
        ) : (
          <div className="course-art">
            <CodeBracketIcon />
            <span>
              {course.cat === "dsa"
                ? "Think. Solve. Repeat."
                : "Build something great."}
            </span>
          </div>
        )}
        <span className="cover-play">
          <PlayIcon />
        </span>
        <span className="free-tag">FREE COURSE</span>
      </Link>
      <div className="course-body">
        <p className="course-category">
          {course.cat === "dsa"
            ? "Data structures & algorithms"
            : course.cat === "Backend"
              ? "Backend development"
              : "Keep exploring"}
        </p>
        <h3>
          <Link
            to="/video-player"
            state={{ playlistID: course.playlistID, tracking: false }}
          >
            {course.title}
          </Link>
        </h3>
        <p className="course-description">
          {course.description ||
            "Make time for a new skill, one lesson at a time."}
        </p>
      </div>
      <div className="course-actions">
        <Link
          to="/video-player"
          state={{ playlistID: course.playlistID, tracking: false }}
        >
          Start learning <ArrowUpRightIcon />
        </Link>
        <button
          disabled={saving}
          onClick={enroll}
          aria-label={`Save ${course.title}`}
        >
          <PlusIcon />
          {saving ? "Saving…" : "Save"}
        </button>
      </div>
    </article>
  );
}
